// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nkby","content":"styles_content__3QzM1"};